<p>servicos works!</p>


<div class="services-container">
    <h2>Nossos Serviços de Fotografia</h2>
  
    <div class="service">
      <h3>Fotografia de Retrato</h3>
      <p>Sessões fotográficas personalizadas para capturar a beleza única de cada indivíduo.</p>
      <p class="price">Preço: $150</p>
    </div>
  
    <div class="service">
      <h3>Filmagem de Eventos</h3>
      <p>Cobertura cinematográfica de eventos especiais para preservar momentos inesquecíveis.</p>
      <p class="price">Preço: $250</p>
    </div>
  
   
  </div>
  
  